import { defineMessage } from 'services/localization';

export const messages = {
    confirmPayment: defineMessage('securely_log_in_to_your_and_confirm_the_payment'),
    loginOnDesktop: defineMessage('log_in_on_desktop'),
    or: defineMessage('or'),
    paymentTotal: defineMessage('payment_total'),
    paymentDate: defineMessage('payment_date_1'),
    payeeName: defineMessage('payee_name'),
    payeeAccountNumber: defineMessage('payee_account_number'),
    payeeSortCode: defineMessage('payee_sort_code'),
    returnTo: defineMessage('return_to_approvalmax_t__updated_payment_status'),
    securelyLogin: defineMessage('scan_the_qr_code_to_use_lect_log_in_via_desktop_1'),
    weHavePartnered: defineMessage('we_have_partnered_with__r_bank_data_at_bankname'),
    termsAndConditions: defineMessage('terms_and_conditions'),
    privacyNotice: defineMessage('privacy_notice'),
    byUsingYouAgree: defineMessage('by_using_the_service_yo_tions_and_privacynotice'),
};
